import { ConnectorType } from 'apollo/generated/client-operations';
import avigilonMark from 'assets/images/avigilon-mark.svg';
import type { ConnectorCatalogEntry } from 'containers/jobsiteConfiguration/tabs/connectors/drawers/connectorCatalogEntry';
import { AvigilonAccessConnectorDetailsDrawer } from './AvigilonAccessConnectorDetailsDrawer';
import { AvigilonAccessConnectorSetupDrawer } from './AvigilonAccessConnectorSetupDrawer';

export const avigilonAccessConnectorCatalogEntry: ConnectorCatalogEntry = {
  type: ConnectorType.AvigilonAccess,
  mark: avigilonMark,
  SetupDrawer: AvigilonAccessConnectorSetupDrawer,
  DetailsDrawer: AvigilonAccessConnectorDetailsDrawer,
};
